import React from "react";
import { gradients } from "../assets/images/gradients";

const Gradient = ({
  imageName,
  width,
  height,
  className = "",
  style = {},
  top = undefined,
  left = undefined,
  right = undefined,
  bottom = undefined,
}) => {
  const imageSrc = gradients[imageName];

  return (
    <div
      className={`gradient ${className}`}
      style={{
        position: "absolute",
        width,
        height,
        top,
        left,
        right,
        bottom,
        pointerEvents: "none",
        ...style,
      }}
    >
      <img
        src={imageSrc}
        alt="gradient"
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
};

export default Gradient;
